import React from 'react';
import logoPositive from '../assets/brand/logo-horizontal-colour-positive.png';
import logoNegative from '../assets/brand/logo-horizontal-colour-negative.png';
import markPositive from '../assets/brand/mark-colour-positive.png';

// Born Digital logo lockups from the Steel Glass design system. The artwork
// ships as files in four finishes and is never recoloured in CSS; the boxes
// are the even-integer sizes the system defines (horizontal 100×24 · 134×32 ·
// 168×40, mark 24 · 32 · 40 · 48) with the image contained inside.
const HORIZONTAL_WIDTHS = { 24: 100, 32: 134, 40: 168 };

export function Logo({ height = 32, negative = false }) {
  const width = HORIZONTAL_WIDTHS[height] || Math.round((height * 168) / 40);
  return (
    <img
      className="brand-logo"
      src={negative ? logoNegative : logoPositive}
      width={width}
      height={height}
      alt="Born Digital"
      draggable={false}
    />
  );
}

export function Mark({ size = 32 }) {
  return (
    <img
      className="brand-mark"
      src={markPositive}
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      draggable={false}
    />
  );
}

// Full-screen loading state: the horizontal logo and a state caption. The
// system has no spinner; the logo sits still ("no effects on the logo").
export function LoadingScreen({ label = 'Loading...' }) {
  return (
    <div className="loading" role="status">
      <Logo height={32} />
      <span className="loading-caption">{label}</span>
    </div>
  );
}
